class Rules {
  constructor(rules) {
    // rules is either ruleset name or a dict containing the custom rules
    if (typeof rules === 'string') {
      return this.constructor[rules];
    }

    return rules;
  }
}

export default Rules;
